module.exports = __webpack_public_path__ + "static/ocean-624b75f008ba4f21d3bc45396b0fcf54.jpg";